<template>
  <a-config-provider :locale="zh_CN">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>
<script>
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN"; //加载ant-design-vue中文语系
import en_US from "ant-design-vue/lib/locale-provider/en_US"; //加载ant-design-vue英文语系

import moment from "moment";
import "moment/locale/zh-cn"; //加载时间控件中文语系

//引入中文语系
moment.locale("zh-cn");
export default {
  data() {
    return {
      zh_CN,
    };
  },
  methods: {
    changeLocale(e) {},
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue